// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"e8e14343","253":"67a9b9d6"}[chunkId] + ".chunk.js";
};